<template>
  <ButtonGroupBlock
    :cols="mappedCols"
    :cols-centered="item.fields.linkGroupCenteredInRow ?? true"
    :content-centered="item.fields.linksGroupCentered ?? false"
    :content="linkList"
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'links'
      })
    "
  />
</template>

<script setup lang="ts">
import { ButtonGroupBlock } from '@hypercodestudio/basler-components';
import type { ILinksGroup } from '~~/lib/ContentfulService';
import { getLinkIconPosition } from '~/utils/getLinkIconPosition';
import { isEntryResolveError } from '~/utils/guards/isEntryResolveError';
const { $ContentfulLivePreview } = useNuxtApp();

interface Props {
  item: ILinksGroup;
}

const props = defineProps<Props>();

// Der Link Type beinhaltet aktuell nur einen Text. Hypercode wurde in Ticket #1260 darüber informiert.
const linkList = computed(
  () =>
    props.item.fields.links
      ?.filter((entry) => !isEntryResolveError(entry))
      ?.map((field) => {
        return {
          text: field.fields.linkText ?? '',
          link: useBuildLinkInterface(field),
          styleType: field.fields.linkStyle ?? 'default',
          targetBlank: field.fields.linkTarget === '_blank',
          size: field.fields.linkStyleSize,
          iconType: getLinkIconPosition(field.fields.linkIconPosition),
          iconName: field.fields.linkIcon
        };
      }) ?? []
);

const mappedCols = computed(() =>
  parseInt(props.item.fields.linksGroupWidth.replace(' cols', ''))
);
</script>
